import { Gender } from "@/enum/gender";
import { Address } from "./address";
import { ShoppingCart } from "@/models/shopping";
import { i18n } from "vue-lang-router";

/**
 * CUSTOMER GROUP
 *  "General public", "Habile", "Gpnet", "Flying blue", "Empowerment"
 */
export class Customer {
  id?: string;
  gender?: Gender;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  birthDate?: string;
  locale?: string;
  customerGroup?: string;
  shoppingCart?: ShoppingCart | null;
  defaultBillingAddress?: string | null;
  defaultShippingAddress?: string | null;
  addresses?: Address[];
  newsLetterSubscribed?: boolean;
  twoFactorAuthenticationEnabled?: boolean;
  oneTimePassword?: string;
  miles?: number;
  isEmpowermentAdmin?: boolean;
  mustUpdatePassword?: boolean;

  public static of(data: any): Customer {
    const c: Customer = new Customer();
    c.miles = data?.miles | 12500;
    c.id = data?.id;
    c.gender = data?.gender;
    c.firstName = data?.firstName;
    c.lastName = data?.lastName;
    c.email = data?.email;
    c.password = data?.password;
    c.birthDate = data?.birthDate;
    c.locale = data?.locale;
    c.customerGroup = data?.customerGroup;
    c.shoppingCart = data?.shoppingCart ? ShoppingCart.of(data?.shoppingCart) : null;
    c.defaultBillingAddress = data?.defaultBillingAddress || null;
    c.twoFactorAuthenticationEnabled = data?.twoFactorAuthenticationEnabled || false;
    c.defaultShippingAddress = data?.defaultShippingAddress || null;
    c.addresses = data?.addresses ? data?.addresses.sort((a, b) => {
      return a.name < b.name ? 1 : -1;
    }) : [];
    c.newsLetterSubscribed = data?.newsLetterSubscribed || false;
    c.isEmpowermentAdmin = data?.additionalAttributes?.isEmpowermentAdmin === "true";
    c.mustUpdatePassword = data?.mustUpdatePassword;
    return c;
  }

  public static getAddress(customer: Customer, addressName: string): Address | null {
    if (customer.addresses) {
      const address = customer.addresses.find(address => address.name === addressName);
      if (address) {
        return address;
      }
    }
    return null;
  }

  public static getCustomerGroup(customerGroup: string) {
    switch (customerGroup) {
      case "General public":
        return i18n.t("customerGroup.label.public");
        break;
      case "Air France employee":
        return i18n.t("customerGroup.label.airFrance");
        break;
      case "Air France services":
        return i18n.t("customerGroup.label.airFranceServices");
        break;
      case "Habile":
        return i18n.t("customerGroup.label.habile");
        break;
      case "Gpnet":
        return i18n.t("customerGroup.label.gpnet");
        break;
      case "Flying blue":
        return i18n.t("customerGroup.label.flyingBlue");
        break;
      case "Empowerment":
        return i18n.t("customerGroup.label.empowerment");
        break;
    }
  }

}